import { render, staticRenderFns } from "./BcCharts.vue?vue&type=template&id=1fa5a9e6"
import script from "./BcCharts.vue?vue&type=script&lang=js"
export * from "./BcCharts.vue?vue&type=script&lang=js"
import style0 from "./BcCharts.vue?vue&type=style&index=0&id=1fa5a9e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports